import { makeStyles } from "tss-react/mui";
import { Nullable } from "@/types/common";

export const useStyles = makeStyles<{
  feedbackRating: Nullable<string>;
  feedbackComment: Nullable<string>;
  feedbackTooSlow: boolean;
  feedbackWrongOutput: boolean;
}>()(
  (
    theme,
    { feedbackRating, feedbackComment, feedbackTooSlow, feedbackWrongOutput }
  ) => ({
    feedbackContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      width: "100%",
    },
    feedbackLabel: {
      fontSize: "0.75rem !important",
    },
    upvote: {
      fontSize: "1rem",
      color:
        feedbackRating === "upvote"
          ? theme.palette.secondary.main
          : theme.palette.primary.light,
    },
    downvote: {
      fontSize: "1rem",
      color:
        feedbackRating === "downvote"
          ? theme.palette.secondary.main
          : theme.palette.primary.light,
    },
    feedbackComment: {
      fontSize: "1rem",
      color:
        feedbackComment || feedbackTooSlow || feedbackWrongOutput
          ? theme.palette.secondary.main
          : theme.palette.primary.light,
    },
    modal: {
      padding: theme.spacing(12, 4),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: 600,
      maxWidth: "100vw",
    },
    presetsContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      gap: theme.spacing(1),
    },
    feedbackTooSlow: {
      width: 150,
      fontSize: 12,
      color: feedbackTooSlow
        ? theme.palette.secondary.main
        : theme.palette.primary.main,
    },
    feedbackWrongOutput: {
      width: 150,
      fontSize: 12,
      color: feedbackWrongOutput
        ? theme.palette.secondary.main
        : theme.palette.primary.main,
    },
    textField: {
      overflow: "auto",
      maxHeight: 200,
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(8),
    },
    submitButton: {
      width: 100,
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
  })
);
